import { render, staticRenderFns } from "./general_sidebar.vue?vue&type=template&id=4222847c&scoped=true&"
import script from "./general_sidebar.vue?vue&type=script&lang=js&"
export * from "./general_sidebar.vue?vue&type=script&lang=js&"
import style0 from "./general_sidebar.vue?vue&type=style&index=0&id=4222847c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4222847c",
  null
  
)

export default component.exports